import { render, staticRenderFns } from "./CryptoAddressModal.vue?vue&type=template&id=4b346ed7&scoped=true&"
import script from "./CryptoAddressModal.vue?vue&type=script&lang=js&"
export * from "./CryptoAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b346ed7",
  null
  
)

export default component.exports